/* @flow */
import React from 'react';

import cx from 'classnames';

import './styles/HovercardFooter.scss';

class HovercardFooter extends React.Component {
  render() {
    return (
      <div {...this.props} className={cx('HovercardFooter', this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}

export default HovercardFooter;



// WEBPACK FOOTER //
// ./src/components/HovercardFooter.jsx